import React, { useRef, useState } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Paper
} from '@mui/material';
import {
    ChevronRight,
    ChevronLeft,
    CalendarToday
} from '@mui/icons-material';
import {
    DatePicker,
    LocalizationProvider
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const DateSlider = ({handleChangeDate}) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const [startDate, setStartDate] = useState(today);
    const [selectedDate, setSelectedDate] = useState(today);
    const [openPicker, setOpenPicker] = useState(false);
    const calendarRef = useRef(null);

    const generateDates = (start) => {
        return Array.from({ length: 7 }, (_, i) => {
            const date = new Date(start);
            date.setDate(start.getDate() + i);
            return date;
        });
    };

    const goNextWeek = () => {
        const next = new Date(startDate);
        next.setDate(startDate.getDate() + 7);
        setStartDate(next);
    };

    const goPrevWeek = () => {
        const prev = new Date(startDate);
        prev.setDate(startDate.getDate() - 7);
        setStartDate(prev);
    };

    const isSameDay = (d1, d2) =>
        d1.toDateString() === d2.toDateString();

    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const dates = generateDates(startDate);

    const handleDateChange = (date) => {
        if (date) {
            const pickedDate = new Date(date);
            pickedDate.setHours(0, 0, 0, 0);
            setSelectedDate(pickedDate);
            handleChangeDate(pickedDate)
            const weekStart = new Date(pickedDate);
            weekStart.setDate(pickedDate.getDate() - (pickedDate.getDay()));
            setStartDate(weekStart);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    // backgroundColor: '#D6ECF0',
                    borderRadius: 2,
                    padding: { xs: 0.5, sm: 0.5, md: 1 },
                    overflow: 'hidden',
                    width:{
                       xs: '100%', sm: '100%', md: '92%', lg:'90%' , xl: '70%'
                    },
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                }}
            >
                <IconButton onClick={goPrevWeek} size="small" sx={{ flexShrink: 0, p: { xs: 0.25, md: 1 } }}>
                    <ChevronLeft />
                </IconButton>

                <Box
                    sx={{
                        display: 'flex',
                        gap: { xs: 0.25, sm: 0.5, md: 1 },
                        overflowX: 'auto',
                        paddingY:1,
                        flex: 1,
                        minWidth: 0,
                        justifyContent: { xs: 'space-between', md: 'flex-start' },
                    }}
                >
                    {dates.map((date) => (
                        <Paper
                            key={date.toDateString()}
                            elevation={isSameDay(date, selectedDate) ? 4 : 0}
                            onClick={() => {
                                setSelectedDate(date)
                                handleChangeDate(date)
                            }}
                            sx={{
                                padding: { xs: '4px 6px', sm: '6px 8px', md: '8px 12px' },
                                textAlign: 'center',
                                borderRadius: 2,
                                minWidth: { xs: 0, sm: 28, md: 33 },
                                flex: { xs: 1, md: 'unset' },
                                // Height:40,
                                cursor: 'pointer',
                                border: isSameDay(date, selectedDate) ? '1px solid #919191' : 'none',
                                transition: 'all 0.3s ease',
                                boxShadow:'none'
                            }}
                        >
                            <Typography variant="body2" sx={{ color: '#555', fontSize: { xs: '11px', sm: '12px', md: '14px' } }}>
                                {days[date.getDay()]}
                            </Typography>
                            <Typography variant="h6" sx={{ fontSize: { xs: '14px', sm: '16px', md: '20px' } }}>
                                {date.getDate()}
                            </Typography>
                        </Paper>
                    ))}
                </Box>

                <IconButton onClick={goNextWeek} size="small" sx={{ flexShrink: 0, p: { xs: 0.25, md: 1 } }}>
                    <ChevronRight />
                </IconButton>

                <DatePicker
                    open={openPicker}
                    onClose={() => setOpenPicker(false)}
                    value={selectedDate}
                    onChange={handleDateChange}
                    slotProps={{
                        textField: { style: { display: 'none' } },
                        popper: {
                            placement: 'bottom-start',
                            anchorEl: calendarRef.current
                        }
                    }}
                />
                <IconButton onClick={() => setOpenPicker(true)} ref={calendarRef} size="small" sx={{ flexShrink: 0, p: { xs: 0.25, md: 1 } }}>
                    <CalendarToday />
                </IconButton>
            </Box>
        </LocalizationProvider>
    );
};

export default DateSlider;
